<template>
  <vehicles />
</template>

<script>
import vehicles from "@/components/3pl/Settings/Vehicles/index";
export default {
  components: {
    vehicles,
  },
};
</script>

<style></style>
